import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { Box, LoadingOverlay } from '@mantine/core';

import { checkAuthAction } from '@/store/api-actions/renew-auth.ts';
import { selectUser } from '@/store/user-process/user-selectors.ts';

import { AppRoutes } from '@/router/routes.ts';

import { useAppDispatch, useAppSelector } from '@/hooks';

const ProtectedRoute = () => {
	const dispatch = useAppDispatch();
	const user = useAppSelector(selectUser);
	const isSessionExpired = Boolean(
		user?.access_expires_at && new Date(user.access_expires_at) < new Date(),
	);

	useEffect(() => {
		if (isSessionExpired) {
			void dispatch(checkAuthAction());
		}
	}, [dispatch, isSessionExpired]);

	if (!user?.access_token) {
		return <Navigate to={AppRoutes.Login} replace />;
	}

	if (isSessionExpired) {
		return (
			<Box pos="relative" h="100%">
				<LoadingOverlay visible zIndex={1000} />
			</Box>
		);
	}

	return <Outlet />;
};

export default ProtectedRoute;
